export async function productShowReservedUseCase(product_id, productRepository) {
    const result = await productRepository.product_show_reserved(product_id);

    const product = new productRepository.model_show_reserved(result.data);
    
    if (!product.isValid()) {
        throw new Error("product show reserved inválido");
    }

    return product;
}